import { render, staticRenderFns } from "./GoodsTabsChooseJoint.vue?vue&type=template&id=43359392&scoped=true&"
import script from "./GoodsTabsChooseJoint.vue?vue&type=script&lang=js&"
export * from "./GoodsTabsChooseJoint.vue?vue&type=script&lang=js&"
import style0 from "./GoodsTabsChooseJoint.vue?vue&type=style&index=0&id=43359392&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43359392",
  null
  
)

export default component.exports